<!-- 商户报表详情下级 -->
<template>
  
  <div class="comContent body-box">
    <div class="body-title">
      <div class="body-title-left">{{shopName}}~{{ deptName }}</div>
      <div class="body-title-right"><el-button size="small" @click="goBack">返回</el-button></div>
    </div>
    <div class="body-tools">
      <div class="body-tools-left">
        <el-form ref="formTool" :model="formTool" :inline="true">
          <el-form-item label="" prop="">
            <el-input v-model="formTool.orderCode" size="small" placeholder="请输入订单编号" clearable />
          </el-form-item>
          <el-form-item label="" prop="">
            <el-date-picker v-model="formTool.orderTime" size="small" type="daterange" value-format="yyyy-MM-dd" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="" prop="phone">
            <MyButton type="primary" text="查询" @click="goSearch" />
            <el-button size="small" @click="formToolReset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="body-tools-right">
        <!-- <MyButton type="primary" text="返回" @click="goBack" /> -->
      </div>
    </div>
    <div class="body-table">
      <MyTable :table-data="tableData"
        max-height="calc(100% - 44px)"
        :index="false"
        :selection="false"
        :page="page"
        :operation="false"
        :table-option.sync="tableOption"
        @page-change="getList"
        @sort-change="sortChange"
        @handleSelectionChange="currentChange">
        <template slot="type" slot-scope="scope">
          <span>{{ scope.row.type=='ios'?'苹果系统':'安卓系统' }}</span>
        </template>
        <template slot="tools" slot-scope="scope">
          <div style="display:flex">
            <el-link type="primary" :underline="false" size="small" @click="goLink(scope.row)">订单明细</el-link>
          </div>
        </template>
      </MyTable>
    </div>
  </div>
</template>

<script>

import MyButton from '@/components/myButton'
import MyTable from '@/components/myTable';
import { queryGoodsSalesEcharts, queryGoodsSalesEchartsExport } from "@/api/statistics";
export default {
  name:'ReportMerchantDetailMore',
  components: { MyButton, MyTable },
  data() {
    return {
      shopId:'',
      shopName:'',
      deptId:'',
      deptName:'',
      formTool: {
        orderCode:'',
        orderTime:'',
      },
      tableData: [],
      tableOption: [
        { label: '订单创建时间', prop: 'order_time',  },
        { label: '订单编号', prop: 'related_order_code',  },
        { label: '订单金额(元)', prop: 'amount',  sortable:'custom'},// ,sortable:'custom'
        { label: '操作', prop: 'tools', slot: true,  }
      ],
      sortStatus:'up',
      page: { total: 10, current: 1, size: 10 },
    };
  },
  // computed: {},
  // watch: {},
  created() {
    let query = this.$route.query;
    if(query.shopId && query.shopName && query.deptId && query.deptName){
      this.shopId = query.shopId;
      this.shopName = query.shopName;
      this.deptId = query.deptId;
      this.deptName = query.deptName;
      this.initData();
    }else{
      this.goBack();
    }
  },
  mounted() {

  },
  methods: {
    goLink(el){
      // http://localhost:8080/#/business/businessManage-order-detail?id=1746514228276228098
      let url = `/business/businessManage-order-detail?id=${el.order_id}`; // related_order_code,order_id
      // let url = type==1?'/reportCustomer/reportCustomer-reportDetail':'/reportCustomer/reportCustomer-reportDetailMore'
      this.$router.push(url);
    },
    goSearch(){
      this.sortStatus = 'up';
      // this.sortType = '1';
      this.initData();
    },
    sortChange(el){
      const { column, prop, order } = el; // order释义：descending:降,ascending:升,为空时代表不选中
      this.sortStatus = order == 'descending'?'down':'up';
      // sortType:'1',// 排序字段: 订单量 1,商品销量 2,采购额（元） 3,客单价（元） 4,首次下单时间 5,最后下单时间 6,最后访问时间 7
      // this.sortType = (order && propNames[prop]) ? propNames[prop].value : '1';
      // console.log( order)
      this.getList();
      // 执行条件搜索操作
    },
    formToolReset () {
      this.formTool = {
        orderCode:'',
        orderTime:'',
      }
      // this.$refs.formTool.resetFields()
      this.initData();
    },
    currentChange(){},
    initData(){
      this.page.current = 1;
      this.getList();
    },
    getList(){
      // console.log('getList-重新加载数据')
      let obj = this.getParams(this.sortStatus);
      let totalObj = this.getParams('total');
      queryGoodsSalesEcharts(obj).then(list=>{
        this.tableData = list || [];
      })
      queryGoodsSalesEcharts(totalObj).then(list=>{
        // 获取总条数
        let total = 0;
        if(list && list.length>0){
          total = parseInt(list[0].cnt);
        }
        this.page.total = total;
      })
    },
    
    getParams(status){
      const { current, size } = this.page;
      const { orderCode, orderTime } = this.formTool;
      let firstSTime = '';
      let firstETime = '';
      if(orderTime && orderTime.length>0){
        firstSTime = orderTime[0].replaceAll('-', '');
        firstETime = orderTime[1].replaceAll('-', '');
      }
      let types = {
        up: 105, down: 106, total: 107,
      }
      let type = types[status];
      let params = [
        this.shopId,// 客户ID
        this.deptId,// 部门ID
        orderCode,orderCode, // 订单编号
        firstSTime,firstSTime, // 开始时间
        firstETime,firstETime, // 结束时间
      ]
      let paramsMore = [
        size, // 每页行数
        (current - 1)*size, // 第几行开始
      ]
      return { type, params: (status=='up' || status=='down') ? [ ...params, ...paramsMore ] : params}
    },
    goBack () {
      // console.log('go back');
      // this.$router.push("/reportMerchant/reportMerchant-reportList");

      // this.$router.go(-1)：后退+刷新；
      // this.$router.go(0)：刷新；
      // this.$router.go(1) ：前进
      this.$router.back(); //:后退
      // this.$router.back(0) 刷新；
      // this.$router.back(1)：前进
    },
  },
  // beforeCreate() { },
  // beforeMount() { },
  // beforeUpdate() { },
  // updated() { },
  // beforeDestroy() { },
  // destroyed() { },
  // activated() { },
}
</script>
<style lang='scss' scoped>
.body{
  &-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    border-bottom: 1px solid #eee;
    &-left{
      width: calc(100% - 90px);
      line-height: 1;
      font-size: 26px;
      font-weight: 600;
      color: #000;
    }
    &-right{
      width: 90px;
      text-align: right;
    }
  }
  &-tools{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 16px;
    &-left{
      width: calc(100% - 90px);
    }
    &-right{
      width: 90px;
      text-align: right;
    }
    ::v-deep .el-form{
      &-item{
        margin-bottom: 6px !important;
      }
    }
  }
  &-table{
    height: calc(100% - 130px);
  }
}
</style>
